import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { TrainingDoctype } from '../course-assignments';

type GetPendingStageSignoffsForUserOptions = CommonRequestOptions & {
   query?: string;
   order?: 'DESC' | 'ASC';
   offset?: number;
   limit?: number;
};

type UserData = {
   userid: number;
   username: string;
   userAvatar: string;
   userProfile: string;
};

export type PendingStageSignoffRequest = {
   signoff_requestid: number;
   created_at: number;
   course: {
      wikiid: number;
      title: string;
   };
   courseStage: {
      doctype: TrainingDoctype;
      docid: number;
      title: string;
   };
   requestor: UserData;
   requestee: UserData;
   work_log_entryid: number | null;
};

type GetPendingStageSignoffsForUserResponse = {
   hasMore: boolean;
   signoffRequests: PendingStageSignoffRequest[];
};

export async function getPendingStageSignoffsForUser(
   userid: number,
   { query, order, offset, limit, ...common }: GetPendingStageSignoffsForUserOptions = {}
): Promise<GetPendingStageSignoffsForUserResponse> {
   return makeRequest('get', `/courses/stage-sign-offs/requests/pending/${userid}`, {
      ...common,
      query: {
         query,
         order,
         offset,
         limit,
      },
   });
}
